export default __webpack_public_path__ + "static/media/ecommerce.73638fe2.png";